<template>
  <div class="table-responsive">
    <table class="table mb-0">
      <thead class="table-light">
        <tr>
          <th>Α/Α</th>
          <th>Τύπος</th>
          <th>Ληφθείσες</th>

        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(stat,index) in holidayStats"
          :key="index"
        >
          <th scope="row">{{index + 1 }}</th>

          <td>{{ stat.holiday_type__title }}</td>
          <td>{{ stat.total_days }}</td>
        </tr>

      </tbody>
    </table>

  </div>
</template>



<script>
export default {
  props: ["holidayStats"],
  data() {
    return {};
  },
};
</script>